import React from 'react';

import { InfoCard } from '@eika/card';

interface NoSharedEfakturaInfoProps {
    headerText: string;
    bodyText: string;
    testID?: string;
}
const NoSharedEfakturaInfo = ({ headerText, bodyText, testID }: NoSharedEfakturaInfoProps) => (
    <InfoCard className="no-shared-efaktura-info" {...(testID ? { 'data-testid': testID } : {})}>
        <h3>{headerText}</h3>
        <span>{bodyText}</span>
    </InfoCard>
);
export default NoSharedEfakturaInfo;
